export const UNIQUE_ID_PREFFIX = 'project_time_entry_temp_';

export const minToHoursInput = (minutes: number): number => {
  return +(minutes / 60).toFixed(2);
};
